import React, { useEffect, useState } from 'react';
import s from '../../../../shared/ui/modal/Modal.module.css';
import Modal from '../../../../shared/ui/modal/Modal';
import { getRecentProjects, updateProject } from '../../../../shared/api/textProjectApi';
import { useAppDispatch } from '../../../../store/store';
import { CurrentProject } from '../../../../shared/types/projectTypes';
import { selectUser } from '../../../../store/selectors/authSelectors';
import { useSelector } from 'react-redux';
import Button from '../../../../shared/ui/button/Button';
import { toast } from 'react-toastify';
interface RenameModalProps {
    isOpen: boolean;
    onClose: () => void;
    project: CurrentProject | null;
}

export const RenameModal: React.FC<RenameModalProps> = ({ isOpen, onClose, project }) => {
    const dispatch = useAppDispatch();
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const user = useSelector(selectUser);

    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(e.target.value);
    };

    useEffect(() => {
        if (project) setTitle(project?.title ?? '');
    }, [project]);

    const handleRename = async () => {
        if (!title.trim() || title === project?.title) return;

        try {
            onClose();
            await dispatch(updateProject({ ...project, title }));
            toast.success('Project renamed successfully');
        } catch (err: any) {
            toast.error(err?.message || 'Failed to rename project');
            console.error('Failed to rename project', err);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (!loading) {
            onClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            showHeader={false}
            width="300px"
            background="white"
        >
            <div className={s.post_modal}>
                <input
                    type="text"
                    value={title}
                    onChange={handleTitleChange}
                    autoFocus
                    className={s.rename_input}
                    disabled={loading}
                    placeholder="Enter new title"
                />

                <div className={s.rename_actions}>
                    <Button
                        text="Rename"
                        onClick={handleRename}
                        style={{ width: '100%', background: '#FFDD35' }}
                        state={loading ? 'loading' : title.trim() ? 'enabled' : 'disabled'}
                    />

                    <Button
                        text="Cancel"
                        onClick={handleClose}
                        state={loading ? 'loading' : 'enabled'}
                        style={{ width: '100%', background: '#F8F7F7' }}
                    />
                </div>
            </div>
        </Modal>
    );
};
